import {Message} from "primereact/message";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import ReopenForCorrectionDialog from "../../component/ReopenForCorrectionDialog";
import {useCheckPermission} from "../../hooks/permissionHooks";
import {selectIsSnapshot, selectLifeCycleStateFinal} from "../../redux/persistenceSlice";
import {PERMISSION_RULE_CORRECTION} from "../../util/permissions";

/**
 * Final-Banner auf der Objekt-/Wertseite: Hinweis, dass die Bewertung finalisiert ist, mit Einstieg in die
 * Korrektur (nur mit Korrektur-Recht). Der eigentliche Korrektur-Dialog inkl. Pflicht-Kommentar und
 * Owner-Auswahl ist die gemeinsame {@link ReopenForCorrectionDialog}-Komponente.
 */
export default function PersistenceFinalMessage() {
    const {t} = useTranslation();
    const persistenceIsFinal = useSelector(selectLifeCycleStateFinal);
    const isSnapshot = useSelector(selectIsSnapshot);
    const canCorrect = useCheckPermission(PERMISSION_RULE_CORRECTION);
    const [open, setOpen] = useState(false);

    // Beim Betrachten eines geladenen Snapshots übernimmt das SnapshotMessage-Banner;
    // der Final-Banner (inkl. Korrektur-Einstieg) wird hier dann ausgeblendet.
    if (!persistenceIsFinal || isSnapshot) return null;
    if (!canCorrect) return <Message className="w-full mb-4" text={t("object.finalizedDescription")} />;

    const MessageContent = (
        <div>
            <span>{t("object.finalizedDescription")}</span>
            <span className={"cursor-pointer"} onClick={() => setOpen(true)}>
                {t("object.reopenLabel")}
                <i className="pi pi-wrench ml-1" />
            </span>
        </div>
    );

    return (
        <>
            <Message className="w-full mb-4" content={MessageContent} />
            <ReopenForCorrectionDialog visible={open} onHide={() => setOpen(false)} />
        </>
    );
}
